<template>
  <el-dialog
    :visible.sync="isShow"
    width="700px"
    :close-on-click-modal="false"
    :show-close="!loading"
    top="15vh"
    :title="title"
    custom-class="mediaUploadDialog"
  >
    <el-form
      ref="formData"
      :model="formData"
      :rules="formRules"
      class="demo-form-inline"
      label-width="100px"
    >
      <template v-if="isSquadShow">
        <template v-if="videoType === 'player'">
          <el-form-item label="选择单位">
            <el-select v-model="formData.tempSelect" placeholder="请选择单位">
              <el-option
                v-for="(item, index) in sequadSelectList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="videoType === 'tutorial'">
          <!-- 系统管理员上传教案视屏 -->
          <template v-if="userRole !== 'coach'">
            <el-row>
              <el-col :span="12">
                <el-form-item label="培训协会" prop="organUuid">
                  <el-select
                    v-model="formData.organUuid"
                    style="width: 100%"
                    placeholder="请选择培训协会"
                    @change="handleOrgChangeToGetSeqList"
                  >
                    <el-option
                      v-for="item in orgSelectList"
                      :key="item.organUuid"
                      :value="item.organUuid"
                      :label="item.organShortName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="培训机构" prop="youthUuid">
                  <el-select
                    v-model="formData.youthUuid"
                    style="width: 100%"
                    placeholder="请选择培训协会后再选择培训机构"
                  >
                    <el-option
                      v-for="item in seqSelectList"
                      :key="item.uuid"
                      :value="item.uuid"
                      :label="item.youthShortName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <!-- 系统管理员上传球员视频 -->
          <template v-else>
            <el-form-item label="选择单位">
              <el-select v-model="formData.tempSelect" placeholder="请选择单位">
                <el-option
                  v-for="(item, index) in sequadSelectList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
        </template>
      </template>
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题" prop="videoTitle">
            <el-input
              v-model="formData.videoTitle"
              placeholder="请填写视频标题"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="共享设置" prop="sharingStatus">
            <el-select v-model="formData.sharingStatus" style="width: 100%">
              <el-option
                v-for="(item, index) in shareStatusList"
                :key="index"
                :label="item.name"
                :value="item.status"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="描述" prop="videoIntro">
          <el-input
            v-model="formData.videoIntro"
            type="textarea"
            :rows="2"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="上传视频" prop="videoAddress">

          <span ref="OK_FILE_SELECT" style="display: none"></span>
          <el-button
            size="small"
            type="success"
            @click="fileSelect"
          >点击上传
          </el-button>
          <div v-if="ok_file_update_status">
            <span>{{update_file_video.file_name}}</span>
            <el-progress :percentage="update_file_video.progress" :status="update_file_video.status"></el-progress>
          </div>
          <div
            style="color: #606266; line-height: 15px; font-size: 14px;margin-top: 10px;"
          >
            支持asx，asf，mpg，wmv，3gp，mp4，mov，avi，flv格式的文件，且不超过200M
          </div>
          
          <el-upload
            style="display: none"
            class="upload-demo"
            :on-success="handleSuccess"
            action="/api/zuxie/guozi/upload/video"
            :before-upload="handleBeforeUpload"
            :on-error="handleError"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :limit="1"
            :data="videoData"
            :disabled="disabled"
            :file-list="fileList"
          >
            <el-button size="small" type="primary" :disabled="disabled"
              >点击上传</el-button
            >
            <div
              slot="tip"
              class="el-upload__tip"
              style="color: #606266; line-height: 15px; font-size: 14px"
            >
              支持asx，asf，mpg，wmv，3gp，mp4，mov，avi，flv格式的文件，且不超过100M
            </div>
          </el-upload>
          
        </el-form-item>
      </el-row>
    </el-form>
    <div class="btn">
      <el-button type="primary" @click="checkForm">保存</el-button>
      <el-button type="danger" @click="isShow = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mediaReq from "@/api/media";
import media from "@/utils/formRules/media";
import { shareStatusList } from "@/utils/yioks_data";
import squad from "@/api/squad";
import storage from "@/utils/storage";

export default {
  name: "uploadMedia",
  mixins: [media],
  props: {
    showTip: {
      type: Boolean,
      require: true,
    },
    orgInfo: {
      type: Object,
      require: true,
    },
    uuid: {
      type: String,
      require: true,
    },
    type: {
      type: String,
      default: "player",
    },
    title: {
      type: String,
      default: "本地上传视频",
    },
    isSquadShow: {
      type: Boolean,
      require: false,
      default: false,
    },
    sequadSelectList: {
      type: Array,
      required: false,
      default: () => []
    },
    videoType: {
      type: String,
      require: false,
      default: "",
    },
  },
  data() {
    return {
      ok_file_update_status: false,
      update_file_video: {
        progress: 0,
        status: "",
        file_name: "",
      },
      videoData: { video: "" },
      userRole: storage.get("userInfo").userRole,
      fileList: [],
      disabled: false,
      loading: false,
      shareStatusList,
      playerObj: {},
      formData: {
        videoTitle: "",
        videoAddress: "",
        sharingStatus: "Club",
        videoFileName: "",
        videoDuration: "",
        videoIntro: "",
        tempSelect: "", // 冗余数据
        youthUuid: "",
        organUuid: "",
        youthShortName: "",
        organShortName: "",
      },
      videoFilePath: "",
      videoUploadUuid: "",
      orgSelectList: [],
      seqSelectList: [],
    };
  },
  computed: {
    isShow: {
      get() {
        return this.showTip;
      },
      set() {
        this.$emit("update:showTip");
      },
    },
  },

  created() {
    if (this.userRole === "system" || this.userRole === "admin") {
      this.handleSystemToturialList();
    }
  },
  methods: {
    upload() {
      this.playerObj[this.uuid] = this.type;
      this.formData.youthUuid = this.orgInfo.youthUuid;
      this.formData.organUuid = this.orgInfo.organUuid;
      this.formData.youthShortName = this.orgInfo.youthShortName;
      this.formData.organShortName = this.orgInfo.organShortName;
      const { tempSelect, organUuid, youthUuid } = this.formData;
      let orgInfo = this.orgInfo;
      if (tempSelect) {
        orgInfo = JSON.parse(tempSelect);
      }
      let minxinData = {};
      if (this.videoType === "player") {
        minxinData = orgInfo;
      } else if (this.videoType === "tutorial") {
        if (this.userRole === "coach") {
          minxinData = orgInfo;
        }
        if (this.userRole === "system" || this.userRole === "admin") {
          minxinData = {
            organUuid,
            youthUuid,
          };
        }
      }
      if (this.update_file_video.file_name){
        this.formData.videoFileName = this.update_file_video.file_name
      }
      const data = {
        guoziVideo: {
          ...this.formData,
          ...minxinData,
        },
        videoAssociateds: {
          ...this.playerObj,
        },
        videoFilePath: this.videoFilePath,
        videoUploadUuid: this.videoUploadUuid,
      };
      let requset = mediaReq.uploadMedia;
      this.loading = true;
      this.disabled = true;
      requset(data)
        .then((res) => {
          this.loading = false;
          this.disabled = false;
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.$emit("hideUploadDialog", false);
          }
        })
        .catch(() => {
          this.loading = false;
          this.disabled = false;
        });
    },
    checkForm() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.upload();
        } else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },
    handleSuccess(res, file, fileList) {
      const File = file.raw;
      this.formData.videoFileName = File.name;
      const url = URL.createObjectURL(File);
      const audioElement = new Audio(url);
      let result;
      audioElement.addEventListener("loadedmetadata", () => {
        result = audioElement.duration;
        this.$set(this.formData, "videoDuration", parseInt(result));
      });
      this.disabled = false;
      this.$set(this.formData, "videoAddress", res.url);
      this.videoFilePath = res.fileTmp;
      this.$refs["formData"].validateField("videoAddress");
    },
    handleError(fileList) {
      // console.log(err)
      fileList = [];
      this.disabled = false;
      this.$message.error("上传失败");
    },
    handleBeforeUpload(file) {
      // console.log(file)
      const imageReg = /^video\/.*(mp4|asx|asf|mpg|wmv|3gp|3gpp|mov|avi|flv)$/i;
      const imageType = imageReg.test(file.type);
      const imageLimit = file.size / 1024 / 1024 < 100;

      if (!imageType) {
        this.$message.error(
          "请上传asx，asf，mpg，wmv，3gp，mp4，mov，avi，flv等格式的视频"
        );
        this.disabled = false;
      }
      if (!imageLimit) {
        this.$message.error("视频大小不得超过100M");
        this.disabled = false;
      }
      if (imageType && imageLimit) {
        this.videoData.video = file;
      }
      return imageType && imageLimit;
    },
    handleExceed(file, fileList) {
      this.$message.error("最多可上传一个视频文件");
    },
    handleRemove(file, fileList) {
      this.formData.videoDuration = "";
      this.formData.videoFileName = "";
      this.$set(this.formData, "videoAddress", "");
      this.videoFilePath = "";
      this.videoUploadUuid = "";
    },
    // 处理系统管理员上传教案视频
    handleSystemToturialList() {
      let request;
      let data = this.uuid;
      if (this.isSquadShow && this.videoType === "tutorial") {
        request = squad.getOrgListBySystem;
        request(data).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.orgSelectList = res;
        });
      }
    },

    // 获取培训机构列表
    handleOrgChangeToGetSeqList(val) {
      if (val) {
        this.seqSelectList =
          this.orgSelectList.find((item) => {
            return val === item.organUuid;
          }).youthList || [];
      }
    },

    // 断点上文文件
    fileSelect() {
      if (this.update_file_video.status === 'warning') {
        this.$message.error("文件上传中，请稍后重试");
        return;
      }
      var input = document.createElement('input');
      input.type = 'file';
//      input.accept="video/*";
      input.onchange = this.selectFileEvent;
      this.$refs.OK_FILE_SELECT.appendChild(input);
      input.click();
    },
    selectFileEvent(e) {
      let selectFiles = e.srcElement.files;
      if (selectFiles.length <= 0) {
        this.$message.error('未选择文件')
        console.log('ERROR: 未选择文件');
        return
      }
      const imageReg = /^video\/.*(mp4|asx|asf|mpg|wmv|3gp|3gpp|mov|avi|flv|quicktime)$/i
      const imageType = imageReg.test(selectFiles[0].type)
      const imageLimit = selectFiles[0].size / 1024 / 1024 < 200

      if (!imageType) {
        this.$message.error(
          '请上传asx，asf，mpg，wmv，3gp，mp4，mov，avi，flv等格式的视频'
        )
        this.ok_file_update_status = false;
        this.disabled = false
        return
      }
      if (!imageLimit) {
        this.$message.error('视频大小不得超过200M')
        this.ok_file_update_status = false;
        this.disabled = false
        return
      }
      this.formData.videoAddress = "";
      this.videoFilePath = "";
      this.videoUploadUuid = "";
      this.update_file_video.progress = 0;
      this.ok_file_update_status = false;
      this.update_file_video.status = "warning";
      this.update_file_video.file_name = selectFiles[0].name;
      this.update_file_video.progress = 0;
      this.ok_file_update_status = true;
      this.$okFile.file_upload.upload(this, selectFiles[0], 1, this.file_update_call);
    },
    file_update_call(status, process, res) {
      this.update_file_video.progress = process;
      if (status === "UPDATE")
        this.update_file_video.status = "warning";
      else if (status === "ERROR")
        this.update_file_video.status = "exception";
      else if (status === "OK")
        this.update_file_video.status = "success";
      if (status === "OK") {
        this.videoFilePath = res.upload.path;
        this.formData.videoAddress = res.upload.url;
        this.formData.videoFilePath = this.videoFilePath;
        this.videoUploadUuid=res.upload.uuid;
      }
    },

  },
};
</script>

<style  lang="stylus">
.mediaUploadDialog
  .btn
    margin-top 20px
    display flex
    justify-content center
    align-items center
  .upload-demo
    .is-success
      &:hover
        color #4cd964
    .el-upload-list__item-name
      color #4cd964
    .el-progress-bar__inner
      background-color #4cd964
    .el-progress__text
      color #4cd964
</style>
